<template>
  <div>
    <HeaderComponent :headerTitle="headerText" />
    <!-- <div class="main_header" style="margin-top:10px;margin-bottom:0px">Disposition</div> -->
    <v-container fluid grid-list-lg pt-0>
      <v-layout class="ma-0 pa-0" wrap align-center>
        <v-flex class="ma-0 pa-0" xs12>
          <v-row align="center" justify="center">
            <v-col v-if= "currentUser.accessible_dispositions.includes('Brand Call Log') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))" block md="6" sm="12" xs12 :cols="6">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'RTVOperations'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/RTV Icon@2x.png"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">Brand Call-Log</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{Number(inv_status_count["Brand Call-Log"].pending_claim)+Number(inv_status_count["Brand Call-Log"].pending_call_log)+Number(inv_status_count["Brand Call-Log"].pending_brand_inspection)+Number(inv_status_count["Brand Call-Log"].pending_brand_approval)+Number(inv_status_count["Brand Call-Log"].pending_brand_resolution)}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.brand_call_log.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.brand_call_log.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.brand_call_log.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>Call Log:</span>
                                <span class="text-color">{{inv_status_count["Brand Call-Log"].pending_claim==undefined?0:inv_status_count["Brand Call-Log"].pending_claim}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Update Call Log:</span>
                                <span class="text-color">{{inv_status_count["Brand Call-Log"].pending_call_log==undefined?0:inv_status_count["Brand Call-Log"].pending_call_log}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Inspection:</span>
                                <span class="text-color">{{inv_status_count["Brand Call-Log"].pending_brand_inspection==undefined?0:inv_status_count["Brand Call-Log"].pending_brand_inspection}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                                <span>Resolution:</span>
                                <span class="text-color">{{(inv_status_count["Brand Call-Log"].pending_brand_approval==undefined?0:inv_status_count["Brand Call-Log"].pending_brand_approval)+(inv_status_count["Brand Call-Log"].pending_brand_resolution==undefined?0:inv_status_count["Brand Call-Log"].pending_brand_resolution)}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col v-if= "currentUser.accessible_dispositions.includes('Insurance')  || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))" block md="6" sm="12" xs12 :cols="6">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'InsuranceOperations'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/insurance.png"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">Insurance</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{Number(inv_status_count.Insurance.pending_insurance_dispatch)+Number(inv_status_count.Insurance.pending_insurance_approval)+Number(inv_status_count.Insurance.pending_insurance_inspection)+Number(inv_status_count.Insurance.pending_insurance_call_log)+Number(inv_status_count.Insurance.pending_insurance_submission)+Number(inv_status_count.Insurance.pending_insurance_disposition)}}</span>                                  
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.insurance.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.insurance.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.insurance.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>Claims:</span>
                                <span class="text-color">{{inv_status_count.Insurance.pending_insurance_submission==undefined?0:inv_status_count.Insurance.pending_insurance_submission}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Update Claims:</span>
                                <span class="text-color">{{inv_status_count.Insurance.pending_insurance_call_log==undefined?0:inv_status_count.Insurance.pending_insurance_call_log}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Inspection:</span>
                                <span class="text-color">{{inv_status_count.Insurance.pending_insurance_inspection==undefined?0:inv_status_count.Insurance.pending_insurance_inspection}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                                <span>Resolution:</span>
                                <span class="text-color">{{inv_status_count.Insurance.pending_insurance_approval==undefined?0:inv_status_count.Insurance.pending_insurance_approval}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Disposition:</span>
                                <span class="text-color">{{((inv_status_count.Insurance.pending_insurance_dispatch==undefined) && (inv_status_count.Insurance.pending_insurance_disposition==undefined))?0:(inv_status_count.Insurance.pending_insurance_disposition + inv_status_count.Insurance.pending_insurance_dispatch)}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col v-if= "currentUser.accessible_dispositions.includes('RTV') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))" block md="6" sm="12" xs12 :cols="6">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'RTVNew'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/return-box.png"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">RTV</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{(Number(inv_status_count["Brand Call-Log"].pending_dispatch)+Number(inv_status_count["Brand Call-Log"].pending_settlement))}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.rtv.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.rtv.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.rtv.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>DOA Pickup:</span>
                                <span class="text-color">{{inv_status_count["Brand Call-Log"].pending_dispatch==undefined?0:inv_status_count["Brand Call-Log"].pending_dispatch}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Pending Finalisation:</span>
                                <span class="text-color">{{inv_status_count["Brand Call-Log"].pending_settlement==undefined?0:inv_status_count["Brand Call-Log"].pending_settlement}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">

                              </td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border"></td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Replacement') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'Replacement'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/replacement.png"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">Replacement</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{Number(inv_status_count.Replacement.pending_replacement_disposition)+Number(inv_status_count.Replacement.pending_replacement_approved)+(inv_status_count.Replacement.pending_redeployment == undefined ? 0:inv_status_count.Replacement.pending_redeployment)}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.replacement.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.replacement.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.replacement.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>Replacement:</span>
                                <span class="text-color">{{inv_status_count.Replacement.pending_replacement_approved == undefined ? 0:inv_status_count.Replacement.pending_replacement_approved}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Disposition:</span>
                                <span class="text-color">{{(inv_status_count.Replacement.pending_replacement_disposition == undefined ? 0:inv_status_count.Replacement.pending_replacement_disposition)+(inv_status_count.Replacement.pending_redeployment == undefined ? 0:inv_status_count.Replacement.pending_redeployment)}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                              </td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                              </td>
                              <td class="td-border">
                              </td>
                              <td class="td-border">
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Repair') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'RepairOperations'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/repair.png"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">Repair</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{(inv_status_count.Repair.pending_repair_initiation==undefined?0:inv_status_count.Repair.pending_repair_initiation)+(inv_status_count.Repair.pending_repair_quotation==undefined?0:inv_status_count.Repair.pending_repair_quotation)+(inv_status_count.Repair.pending_repair==undefined?0:inv_status_count.Repair.pending_repair)+(inv_status_count.Repair.pending_repair_grade==undefined?0:inv_status_count.Repair.pending_repair_grade)+(inv_status_count.Repair.pending_repair_disposition==undefined?0:inv_status_count.Repair.pending_repair_disposition)+(inv_status_count.Repair.pending_repair_approval==undefined?0:inv_status_count.Repair.pending_repair_approval)+(inv_status_count.Repair.pending_repair_estimate==undefined?0:inv_status_count.Repair.pending_repair_estimate)+(inv_status_count.Repair.pending_repair_completion==undefined?0:inv_status_count.Repair.pending_repair_completion)+(inv_status_count.Repair.pending_redeployment==undefined?0:inv_status_count.Repair.pending_redeployment)}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.repair.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.repair.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.repair.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>Initiations:</span>
                                <span class="text-color">{{inv_status_count.Repair.pending_repair_initiation==undefined?0:inv_status_count.Repair.pending_repair_initiation}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Quotations:</span>
                                <span class="text-color">{{(inv_status_count.Repair.pending_repair_quotation==undefined?0:inv_status_count.Repair.pending_repair_quotation)+(inv_status_count.Repair.pending_repair_estimate==undefined?0:inv_status_count.Repair.pending_repair_estimate)}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Approval:</span>
                                <span class="text-color">{{inv_status_count.Repair.pending_repair_approval==undefined?0:inv_status_count.Repair.pending_repair_approval}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                                <span>Repair:</span>
                                <span class="text-color">{{(inv_status_count.Repair.pending_repair==undefined?0:inv_status_count.Repair.pending_repair)+(inv_status_count.Repair.pending_repair_completion==undefined?0:inv_status_count.Repair.pending_repair_completion)}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Repair Grade:</span>
                                <span class="text-color">{{inv_status_count.Repair.pending_repair_grade==undefined?0:inv_status_count.Repair.pending_repair_grade}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Disposition:</span>
                                <span class="text-color">{{(inv_status_count.Repair.pending_repair_disposition==undefined?0:inv_status_count.Repair.pending_repair_disposition)+(inv_status_count.Repair.pending_redeployment==undefined?0:inv_status_count.Repair.pending_redeployment)}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Redeploy') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'Redeploy'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/redeploy.png"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">Redeploy</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{Number(inv_status_count.Restock.pending_redeploy_destination)+Number(inv_status_count.Restock.pending_redeploy_dispatch)}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.restock.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.restock.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.restock.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>Dispatch:</span>
                                <span class="text-color">{{inv_status_count.Restock.pending_redeploy_dispatch==undefined?0:inv_status_count.Restock.pending_redeploy_dispatch + inv_status_count.Restock.pending_redeploy_destination==undefined?0:inv_status_count.Restock.pending_redeploy_destination}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border"></td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border"></td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Liquidation') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'LotCreation'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/liquidation.png"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">Liquidation</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{Number(data_count.liquidation.high)+Number(data_count.liquidation.medium)+Number(data_count.liquidation.low)}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.liquidation.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.liquidation.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.liquidation.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>Pending Liquidation:</span>
                                <span class="text-color">{{inv_status_count.Liquidation.pending_liquidation==undefined?0:inv_status_count.Liquidation.pending_liquidation}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Pending RFQ:</span>
                                <span class="text-color">{{inv_status_count.Liquidation.pending_rfq==undefined?0:inv_status_count.Liquidation.pending_rfq}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Pending Publish:</span>
                                <span class="text-color">{{inv_status_count.Liquidation.pending_publish==undefined?0:inv_status_count.Liquidation.pending_publish}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                               <span>In Progress:</span>
                                <span class="text-color">{{inv_status_count.Liquidation.inprogress==undefined?0:inv_status_count.Liquidation.inprogress}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Decision Pending:</span>
                                <span class="text-color">{{inv_status_count.Liquidation.decision_pending==undefined?0:inv_status_count.Liquidation.decision_pending}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border"></td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

<!--             <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Pending Transfer Out') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'Markdown'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/markdown.png"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">Pending Transfer Out</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{Number(inv_status_count["Pending Transfer Out"].pending_transfer_out_destination)+Number(inv_status_count["Pending Transfer Out"].pending_transfer_out_dispatch)}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.pending_transfer_out.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.pending_transfer_out.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.pending_transfer_out.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>Destination:</span>
                                <span class="text-color">{{inv_status_count["Pending Transfer Out"].pending_transfer_out_destination==undefined?0:inv_status_count["Pending Transfer Out"].pending_transfer_out_destination}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Dispatch:</span>
                                <span class="text-color">{{inv_status_count["Pending Transfer Out"].pending_transfer_out_dispatch==undefined?0:inv_status_count["Pending Transfer Out"].pending_transfer_out_dispatch}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border"></td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border"></td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
 -->
            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Pending Transfer Out') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'Dispatch'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/markdown.png"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">Dispatch</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{(inv_status_count.Dispatch.pending_pick==undefined?0:inv_status_count.Dispatch.pending_pick)+(inv_status_count.Dispatch.pending_pack==undefined?0:inv_status_count.Dispatch.pending_pack)+(inv_status_count.Dispatch.pending_dispatch==undefined?0:inv_status_count.Dispatch.pending_dispatch)+(inv_status_count.Dispatch.in_dispatch==undefined?0:inv_status_count.Dispatch.in_dispatch)}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">0</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">0</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">0</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>Pending Pick & Pack:</span>
                                <span class="text-color">{{(inv_status_count.Dispatch.pending_pick==undefined?0:inv_status_count.Dispatch.pending_pick)+(inv_status_count.Dispatch.pending_pack==undefined?0:inv_status_count.Dispatch.pending_pack)}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Pending  Dispatch:</span>
                                <span class="text-color">{{(inv_status_count.Dispatch.pending_dispatch==undefined?0:inv_status_count.Dispatch.pending_dispatch)+(inv_status_count.Dispatch.in_dispatch==undefined?0:inv_status_count.Dispatch.in_dispatch)}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border"></td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border"></td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('Pending Disposition') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'PendingDisposition'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/pending_disposition.svg"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">Pending Disposition</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{Number(inv_status_count["Pending Disposition"].pending_disposition_closed)+Number(inv_status_count["Pending Disposition"].pending_disposition)}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.pending_disposition.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.pending_disposition.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.pending_disposition.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td>
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td>
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td>
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                            </tr>
                            <tr align="center" style="border-style: hidden;">
                              <td>
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td>
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col block md="6" sm="12" xs12 :cols="6" v-if= "currentUser.accessible_dispositions.includes('E-Waste') || currentUser.accessible_dispositions.includes('All') || (currentUser.roles.includes('central_admin') || currentUser.roles.includes('site_admin'))">
              <v-card class="rounded-card" :elevation="10">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <router-link class="text-decoration-none" :to="{ name: 'Waste'}">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr align="center">
                              <td style="border:none">
                                <img
                                  align="center"
                                  src="@/assets/images/icons/e-waste.svg"
                                  height="45"
                                  width="45"
                                />
                              </td>
                              <td class="pt-2" colspan="2" style="border:none">
                                <h4 justify="center">E-Waste</h4>
                                <h5 justify="center" class="grey--text">
                                  Open Cases :
                                  <span class="text-color">{{(Number(inv_status_count["E-Waste"].pending_e_waste))+(Number(inv_status_count["E-Waste"].pending_e_waste_dispatch))}}</span>
                                </h5>
                              </td>
                            </tr>

                            <tr align="center" class="ma-1 pa-1 overflow-hidden">
                              <td class="ma-3 pa-3 td-border">
                                <h3 class="high-alert">{{data_count.e_waste.high}}</h3>
                                <span>High alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="medium-alert">{{data_count.e_waste.medium}}</h3>
                                <span>Medium alert</span>
                              </td>
                              <td class="td-border">
                                <h3 class="low-alert">{{data_count.e_waste.low}}</h3>
                                <span>Low alert</span>
                              </td>
                            </tr>

                            <tr align="center">
                              <td class="td-border">
                                <span>E-Waste:</span>
                                <span class="text-color">{{inv_status_count["E-Waste"].pending_e_waste==undefined?0:inv_status_count["E-Waste"].pending_e_waste}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">
                                <span>Dispatch:</span>
                                <span class="text-color">{{inv_status_count["E-Waste"].pending_e_waste_dispatch==undefined?0:inv_status_count["E-Waste"].pending_e_waste_dispatch}}</span>
                                <span>
                                  <img
                                    class="pull-right"
                                    align="center"
                                    src="@/assets/images/arrow.png"
                                    height="18"
                                    width="18"
                                    @click="proceedGrading(item)"
                                  />
                                </span>
                              </td>
                              <td class="td-border">

                              </td>
                            </tr>
                            <tr align="center">
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border">
                                <span></span>
                                <span class="text-color"></span>
                                <span>

                                </span>
                              </td>
                              <td class="td-border"></td>
                            </tr>                            
                          </tbody>
                        </template>
                      </v-simple-table>
                    </router-link>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style>
.v-card {
  max-width: 98% !important;
}

.v-card-100 {
  max-width: 100% !important;
}
.text-color {
  color: #0357d0;
}

.td-border {
  border: 2px solid #e5e5e5;
}
.v-data-table__wrapper {
  overflow-x: inherit !important;
  overflow-y: inherit !important;
}
.high-alert {
  color: #eb5757;
}
.medium-alert {
  color: #ff8b00;
}
.low-alert {
  color: #00875a;
}
.main_wraper {
  float: left;
  width: 100%;
  position: relative;
  padding-left: 125px;
}
</style>

<script>
//import Editor from "@tinymce/tinymce-vue";
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { mapState } from "vuex";
export default {
  data() {
    return {
      headerText: "Disposition",
      data_count:'',
      inv_status_count:'',
    };
  },
  computed: mapState(["currentUser", "signedIn"]),
  created() {
    this.getDispositionCount();
    this.get_Inventory_Status_Count();
  },
  components: {
    HeaderComponent,
  },

  methods: {
    getDispositionCount() {
      this.$http.secured
        .get("/api/v1/warehouse/inventories/disposition_criticality_count")
        .then((response) => {
          this.data_count = response.data;
          console.log(response.data)
        })
        .catch((error) => {
          this.$toast.error("Error in geting disposition count");
        });
    },
    get_Inventory_Status_Count() {
      this.$http.secured
        .get("/api/v1/warehouse/inventories/inventory_status_count")
        .then((response) => {
          this.inv_status_count = response.data;
          console.log(response.data)
        })
        .catch((error) => {
          this.$toast.error("Error in geting inventory status count");
        });
    },    
  },
};
</script>


// WEBPACK FOOTER //
// src/components/api/v1/wms/Disposition.vue